<script>
import OmniDialog from "@/components/OmniDialog.vue";
import PermissionTooltip from "@/components/PermissionTooltip.vue";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto.ts";

export default {
  name: "ArchiveDispatcherAction",
  components: { PermissionTooltip, OmniDialog },
  props: {
    dispatcher: {
      type: Object,
      required: true,
    },
  },
  emits: ["change"],
  data() {
    return {
      showArchiveConfirmationDialog: false,
      showUnarchiveConfirmationDialog: false,
    };
  },
  computed: {
    DispatcherPermissionValue() {
      return DispatcherPermissionValue;
    },
  },
  methods: {
    showArchiveConfirmation() {
      this.showArchiveConfirmationDialog = true;
    },
    hideArchiveConfirmation() {
      this.showArchiveConfirmationDialog = false;
    },
    showUnarchiveConfirmation() {
      this.showUnarchiveConfirmationDialog = true;
    },
    hideUnarchiveConfirmation() {
      this.showUnarchiveConfirmationDialog = false;
    },
    async archive() {
      const resp = await this.$api.dispatchers.archiveDispatcher(this.dispatcher.id);
      if (resp.success) {
        this.hideArchiveConfirmation();
        this.$emit("change");
      }
    },
    async unarchive() {
      const resp = await this.$api.dispatchers.unarchiveDispatcher(this.dispatcher.id);
      if (resp.success) {
        this.hideUnarchiveConfirmation();
        this.$emit("change");
      }
    },
  },
};
</script>

<template>
  <permission-tooltip v-if="!dispatcher.archived" :permission="DispatcherPermissionValue.ArchiveDispatcher">
    <template #activator="{ disabled }">
      <v-btn
        :disabled="disabled"
        color="primary"
        icon="mdi-archive-arrow-down-outline"
        size="x-small"
        variant="text"
        @click="showArchiveConfirmation"
      ></v-btn>
    </template>

    {{ $t("permission.archive-dispatcher") }}
  </permission-tooltip>

  <permission-tooltip v-else :permission="DispatcherPermissionValue.ArchiveDispatcher">
    <template #activator="{ disabled }">
      <v-btn
        :disabled="disabled"
        color="primary"
        icon="mdi-archive-arrow-up-outline"
        size="x-small"
        variant="text"
        @click="showUnarchiveConfirmation"
      ></v-btn>
    </template>

    {{ $t("permission.unarchive-dispatcher") }}
  </permission-tooltip>

  <omni-dialog
    v-model="showArchiveConfirmationDialog"
    persistent
    primary-action-label="Archive"
    size="small"
    title="Archive dispatcher"
    @primary-action:click="archive"
  >
    <div class="my-4">Are you sure want to send {{ dispatcher.name }}’s account to archive?</div>
  </omni-dialog>
  <omni-dialog
    v-model="showUnarchiveConfirmationDialog"
    persistent
    primary-action-label="Unarchive"
    size="small"
    title="Unarchive dispatcher"
    @primary-action:click="unarchive"
  >
    <div class="my-4">Are you sure want to return {{ dispatcher.name }}’s account from archive?</div>
  </omni-dialog>
</template>

<style lang="scss" scoped></style>
